export const canEditSessionDocument = (editor, clientId, role) => editor
  ? String(editor.id) === String(clientId)
  : role === 'client_admin';

export function signatureAction({ documentId, loading, signable, canEdit, signing, finished }) {
  if (finished) return { enabled: false, reason: 'This session has finished.' };
  if (!documentId) return { enabled: false, reason: 'Open a document to sign.' };
  if (loading) return { enabled: false, reason: 'The document is loading.' };
  if (!signable) return { enabled: false, reason: 'Signing is supported for PDF, Word and OpenDocument text files.' };
  if (!canEdit) return { enabled: false, reason: 'View only. Ask the session administrator to give you editing rights to sign.' };
  if (signing) return { enabled: false, reason: 'A signature is being added.' };
  return { enabled: true, reason: 'Sign the current document' };
}
